import { useEffect, useState } from 'react';

// eslint-disable-next-line import/no-unresolved
import { UserMessageCreateParams } from '@sendbird/chat/lib/__definition';

import {
  channelsMetadata,
  chatActiveTab,
  ClientChatTypes,
  getTypeOfUser,
  TypeOfUser,
} from '@pharmaplan/common';
import { extractNameFromChat } from '@pharmaplan/common/helpers/utils';

import { useAppSelector } from '../useAppSelector';
import { MomentTimeFormats } from '../../helpers/Constants';
import { serverToday } from '../../helpers/Functions';

import ChatManager from './ChatManager';

const { pharmacist, technician, student, pharmacy } = TypeOfUser;
const today = serverToday().toFormat(MomentTimeFormats.fullDate);

const useClientChat = () => {
  const userType: TypeOfUser = useAppSelector(getTypeOfUser);
  const activeTab = useAppSelector(chatActiveTab);

  const [channelUrl, setChannelUrl] = useState({
    url: '',
    personnelId: '',
    channelName: '',
    userType: '',
  });

  const channelMetadata = useAppSelector(channelsMetadata);
  const disableChat = channelMetadata?.[channelUrl.url]?.accessBy < today;

  const { updateCustomType } = ChatManager();
  const [isFirstMessage, setIsFirstMessage] = useState(false);

  const tabToUserMap = {
    [ClientChatTypes.pharmacist]: pharmacist,
    [ClientChatTypes.technician]: technician,
    [ClientChatTypes.student]: student,
    [ClientChatTypes.support]: '',
  };

  const getChannelType = () => {
    if (activeTab === ClientChatTypes.support) {
      return `+${userType}`;
    }

    if (userType === pharmacy) {
      return tabToUserMap[activeTab as keyof typeof tabToUserMap];
    }
    return userType;
  };

  useEffect(() => {
    if (isFirstMessage) {
      updateCustomType(channelUrl.url, getChannelType() ?? '');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFirstMessage]);

  useEffect(() => {
    setIsFirstMessage(false);
  }, [channelUrl.url]);

  const onFirstMessage = (params: UserMessageCreateParams) => {
    setIsFirstMessage(true);
    return params;
  };

  const extractedName = extractNameFromChat(channelUrl.channelName, userType);

  const handleChannelSelect = (channel: any) => {
    const { url: inUrl, _name } = channel ?? {};
    const { user_type: inUserType, personnelId: inPersonnelId } = channelMetadata?.[inUrl] ?? {};

    setChannelUrl({
      userType: inUserType,
      personnelId: inPersonnelId,
      url: inUrl ?? '',
      channelName: _name,
    });
  };

  return {
    onFirstMessage,
    extractedName,
    handleChannelSelect,
    disableChat,
    setChannelUrl,
    channelUrl,
  };
};

export default useClientChat;
